import { ScreenObject } from '@usacsmideo/types';
import { useNavigate } from '@tanstack/react-router';
import type { FileRouteTypes } from '@tanstack/react-router';
import { normalizePortalPath } from '../../../utilities/normalizePortalPath';

export default function IndexScreenCardLink({
  screen,
  stepNumber,
}: {
  screen: ScreenObject;
  stepNumber?: number;
}) {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => {
        navigate({ to: normalizePortalPath(screen.portalPath) as FileRouteTypes['to'] });
      }}
      disabled={screen.disabled ? true : false}
      className="my-4 cursor-pointer"
    >
      <div
        className={`flex flex-row flex-wrap items-center justify-between rounded-lg border-2 border-white bg-[${screen.inactiveBackgroundColor}] px-4 py-2 transition-all duration-75 active:translate-y-0.5 active:shadow-sm active:bg-[${screen.activeBackgroundColor}]`}
      >
        <p
          key={screen.id}
          style={{
            color: screen.disabled ? 'gray' : 'white',
            fontSize: 22,
            fontWeight: 'bold',
          }}
        >
          {stepNumber ? `${stepNumber}. ${screen.displayName}` : screen.displayName}
        </p>
        <p
          style={{
            color: screen.disabled ? 'gray' : 'white',
            fontSize: 22,
            fontWeight: 'bold',
          }}
        >
          {screen.completed ? '\u2713' : ''}
        </p>
      </div>
    </button>
  );
}
